import 'react-toastify/dist/ReactToastify.css'
import './index.css'
import { createRoot } from 'react-dom/client'
import { Root } from 'root'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/react'
import { STORAGE_VERSION } from 'app-constants'

if (localStorage.getItem('storageVersion') !== STORAGE_VERSION) {
  localStorage.setItem('cachedPrices', '{}')
  localStorage.setItem('cachedPriceRanges', '{}')
  localStorage.setItem('storageVersion', STORAGE_VERSION)
}

Sentry.init({
  dsn: 'https://a333bf9d3522b23d997acae1f8cee8e0@o4507412466237440.ingest.de.sentry.io/4507412732903504',
  integrations: [Sentry.browserTracingIntegration()], //Sentry.replayIntegration() // INFO: reply enable
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/phuture\.finance/],
  // Session Replay
  // INFO: uncomment to enable reply mode
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(<Root />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
